<template>
  <div class="your-move">
    <div @click="toHome" class="your-move__arrow-back">
      <img
        class="your-move__arrow-back-img"
        src="../assets/icon/arrow-left.svg"
        alt=""
      />
    </div>

    <div class="your-move__image-wrap">
      <img
        class="your-move__image"
        :src="playersPreset[players[currentPlayer].image].image"
        alt=""
      />
    </div>
    <div class="your-move__plate">
      <div class="your-move__team-title" v-if="!wordIsShown">
        {{ players[currentPlayer].title }} готовы?
      </div>
      <div class="your-move__team-title" v-if="wordIsShown">Выбери слово</div>
      <GoBtn v-if="!wordIsShown" @click="showModal">Показать слова </GoBtn>
      <!--<div class="main-action-btn"-->
      <!--v-if="!wordIsShown"-->
      <!--@click="wordIsShown=!wordIsShown">Выбрать слово-->
      <!--</div>-->
      <div v-if="wordIsShown" class="select-word">
        <div
          class="select-word__item"
          v-for="(item, index) in wordsSet"
          :key="item"
          @click="selectWord({ word: item, score: index + 1 })"
        >
          <div class="">{{ item }}</div>
          <div class="">+{{ index + 1 }}</div>
        </div>
        <transition name="fade">
          <div class="select-word__card" v-if="resolvedWord">
            <div class="select-word__card-word">{{ resolvedWord.word }}</div>
            <Timer
              v-on:timeIsOver="stopTimer"
              v-on:timeIsStart="playAudioClock"
            ></Timer>
            <div class="select-word__btn-wrap">
              <div class="select-word__btn-wrap-ok">
                <GoBtn @click="guessed(resolvedWord)">Отгадали </GoBtn>
              </div>
              <SecondBtn @click="wrong(resolvedWord)">Не отгадали </SecondBtn>
            </div>
          </div>
        </transition>
      </div>
      <div v-if="!wordIsShown" class="your-move__score-list-wrap">
        <div class="your-move__score-wrap">
          <div
            class="your-move__score"
            v-for="(player, index) in players"
            :key="index"
            :class="{ 'your-move__score--active': currentPlayer === index }"
          >
            <div class="">{{ player.title }}</div>
            <div class="">{{ player.score }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Timer from "../components/Timer";

const clockAudio = new Audio(require("@/assets/2.mp3"));
const alarmAudio = new Audio(require("@/assets/1.mp3"));
clockAudio.addEventListener(
  "ended",
  function () {
    this.currentTime = 0;

    this.play();
  },
  false
);

import { mapGetters, mapActions } from "vuex";
import GoBtn from "../components/GoBtn";
import SecondBtn from "../components/SecondBtn";

export default {
  name: "YourMove",
  components: { SecondBtn, GoBtn, Timer },
  mounted: function () {
    this.loadingData();
    this.updWord();
    this.addUsedWord(this.wordsSet);
    this.detectWin();
  },
  computed: {
    ...mapGetters([
      "currentPlayer",
      "players",
      "playersPreset",
      "wordsSet",
      "winner",
    ]),
  },
  data: function () {
    return {
      resolvedWord: null,
      wordIsShown: false,
    };
  },
  methods: {
      //отправляем в вебвью сообщение о подготовке баннера и о его показе
    printMessage(state) {
      Print.postMessage(state);
    },
    showModal() {
      this.wordIsShown = !this.wordIsShown;
      this.printMessage("init")
    },
    playAudioClock: function () {
      clockAudio.play();
    },
    selectWord: function (ResolvedWord) {
      this.resolvedWord = ResolvedWord;
    },
    toHome() {
      this.$router.push("/");
    },
    guessed: function (ResolvedWord) {
      this.stopClock();
      this.addResolvedWord(ResolvedWord);
      this.changePlayer();
      this.detectWin();
      clockAudio.pause();

      if (!this.winner) {
        this.resolvedWord = null;
        this.updWord();
        this.addUsedWord(this.wordsSet);
        this.detectWin();
        this.wordIsShown = false;
      } else {
        this.$router.push("finish");
      }

      // this.printMessage("show")
    },
    stopClock: function () {
      clockAudio.pause();
    },
    playAlarm: function () {
      alarmAudio.play();

      function pause() {
        alarmAudio.pause();
        alarmAudio.currentTime = 0.0;
      }

      setTimeout(pause, 1000);
    },

    stopTimer: function () {
      this.stopClock();
      this.playAlarm();
    },
    wrong: function (ResolvedWord) {
      this.stopClock();
      this.playAlarm();
      this.addUnresolvedWord(ResolvedWord);
      this.changePlayer();

      if (!this.winner) {
        this.resolvedWord = null;
        this.updWord();
        this.addUsedWord(this.wordsSet);
        this.detectWin();
        this.wordIsShown = false;
      } else {
        this.$router.push("finish");
      }

       this.printMessage("show")
    },
    ...mapActions([
      "addUsedWord",
      "addResolvedWord",
      "addUnresolvedWord",
      "changePlayer",
      "updWord",
      "detectWin",
      "loadingData",
    ]),
  },
};
</script>

<style lang="scss">
.your-move {
  height: 100vh;
  width: 100vw;

  display: flex;
  flex-direction: column;
  align-items: center;

  /*&__finish-btn{*/
  /*position: fixed;*/
  /*right: 30px;*/
  /*top: 30px;*/
  /*height: 30px;*/
  /*width: 30px;*/
  /*&-img{*/
  /*max-height: 30px;*/
  /*max-width: 30px;*/
  /*opacity: .2;*/
  /*}*/
  /*}*/
  &__arrow-back {
    position: fixed;
    left: 0;
    top: 20px;
    width: 52px;
    height: 52px;
    cursor: pointer;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0.04);
    display: flex;
    align-items: center;
    justify-content: space-around;
    &-img {
      width: 20px;
    }
  }

  &__plate {
    background-color: #fff;
    overflow: hidden;
    width: calc(100%);
    border-radius: 40px 40px 0 0;
    margin: -30px 0 0;
    position: relative;
    display: flex;
    height: 100%;
    flex-direction: column;
    align-items: center;
    padding: 50px 30px 0 30px;
  }

  &__image-wrap {
    width: 160px;
    margin-top: 20px;
    height: 160px;
    flex: 0 0 160px;
    display: flex;
    border-radius: 40px;
    background: #ffffff;
    /* margin-bottom: 50px; */
    overflow: hidden;
    box-shadow: 0 11px 20px rgba(0, 0, 0, 0.05);
    justify-content: space-around;
    align-items: center;
    z-index: 1;
  }

  &__image {
    max-height: 110px;
    max-width: 110px;
    margin-top: 5px;
  }

  &__team-title {
    font-size: 33px;
    font-weight: 900;
    text-align: center;
    margin: 30px 0 20px;
  }

  &__sub {
    color: #999;
    margin-bottom: 16px;
  }

  &__score-wrap {
    border-radius: 30px 30px 0 0;
    padding: 20px 24px 8px;
    background-color: #f2f2f2;
    color: #999;
    position: relative;
    z-index: 500;
  }
  &__score-list-wrap {
    position: relative;
    margin: auto 0 0;
    width: 100%;
    max-height: 400px;
    overflow-y: scroll;
  }
  &__score-list-wrap-img {
    position: absolute;
    top: -55px;
    left: 50%;
    transform: translateX(-50%);
  }

  &__score {
    width: 100%;
    padding: 10px 0;
    display: flex;
    font-size: 21px;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e4e4e4;
    font-weight: 700;

    &--active {
      color: #333;
    }

    &:last-child {
      border-bottom: none;
    }
  }
}

.main-action-btn {
  width: calc(100% - 36px);
  font-size: 20px;
  text-align: center;
  background: linear-gradient(to top, #ffd800 0%, #ffed19 100%);
  border-radius: 50px;
  padding: 12px;
  height: 60px;
  display: flex;
  color: #000;
  text-decoration: none;
  font-weight: 700;
  box-shadow: 0 5px 10px rgba(125, 104, 1, 0.16);
  align-items: center;
  justify-content: space-around;
  margin-bottom: 8px;
}

.select-word {
  width: 100%;
  padding: 0 16px;

  &__item {
    padding: 16px 24px;
    font-size: 20px;
    background: #f2f2f2;
    border: 1px solid #eee;
    border-radius: 50px;
    margin-bottom: 8px;
    text-align: center;
    width: 100%;
    display: flex;
    font-weight: 800;
    align-items: center;
    justify-content: space-between;
  }

  &__card {
    position: fixed;
    border-radius: 30px;
    bottom: 16px;
    transform: translateX(-50%);
    left: 50%;
    width: calc(100% - 36px);
    margin-top: auto;
    height: auto;
    background: #ffffff;
    z-index: 80000;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-shadow: 0 0 150px 50px rgba(0, 0, 0, 0.2);
  }

  &__card-word {
    margin-top: 50px;
    margin-bottom: 40px;
    font-size: 34px;
    font-weight: 700;
    background-color: #f2f2f2;
    padding: 10px 13px;
    border-radius: 10px;
  }

  &__btn-wrap {
    display: flex;
    flex-direction: column;
    padding: 50px;
    width: 100%;
    &-ok {
      margin-bottom: 12px;
    }
  }

  &__card-word-suc {
    font-size: 18px;
    width: 100%;
    background: #00bb0e;
    border: 0;
    border-radius: 10px;
    padding: 24px;
    color: #fff;
    margin-right: 10px;
  }

  &__card-word-wrong {
    font-size: 18px;
    background: #f84217;
    border: 0;
    width: 72px;
    border-radius: 10px;
    padding: 24px;
    color: #fff;
  }
}

.fade-enter-active {
  animation: bounce-in 0.2s;
}

.fade-leave-active {
  animation: bounce-in 0.2s reverse;
}

@keyframes bounce-in {
  0% {
    transform: translateY(50px) translateX(-50%);
    opacity: 0;
  }
  100% {
    transform: translateY(0) translateX(-50%);
    opacity: 1;
  }
}
</style>
